<script lang="ts">
  import ContentPageLayout from '$lib/components/website/pageLayout/ContentPageLayout.svelte';
  import HomepageLayout from '$lib/components/website/pageLayout/HomepageLayout.svelte';
  import { page } from '$app/stores';
  import { makePanelOption } from '$lib/helpers/makePanelOption';
  import Breadcrumbs from '$lib/components/website/Breadcrumbs.svelte';
  import Button from '$lib/components/control/Button.svelte';
  import { BUTTON_VARIANT, BUTTON_SIZE, CONTENT_TYPES } from '$lib/constants/constants';
  import { ensureOptimizely, optimizelyStore } from '$lib/stores/optimizelyStore';
  import { onMount } from 'svelte';

  export let data;
  let path;
  $: path = $page.url.pathname;

  const hasVariationContainer = data.pageData?.panelsCollection.find(
    (panel) => panel?.contentType === CONTENT_TYPES.VARIATION_CONTAINER,
  );

  onMount(async () => {
    if (hasVariationContainer && !$optimizelyStore.isReady) {
      await ensureOptimizely();
    }
  });
</script>

{#if path === '/'}
  <HomepageLayout>
    {#if !hasVariationContainer || (hasVariationContainer && $optimizelyStore.isReady)}
      {#each data.pageData?.panelsCollection as panel, index}
        <div class="w-full mx-auto {makePanelOption(panel, 'homePage', index).style}">
          <svelte:component
            this={makePanelOption(panel, 'contentPage', index).component}
            {...makePanelOption(panel, 'contentPage', index).props}
          />
        </div>
      {/each}
    {/if}
  </HomepageLayout>
{:else}
  <ContentPageLayout>
    <div class="px-4 lg:px-8 py-4 lg:py-8 w-full mx-auto max-w-1280">
      <Breadcrumbs
        links={[
          { label: 'Sweat', href: '/' },
          {
            label: `${data.pageData.seoPageTitle}`,
            href: `${data.pageData.slug}`,
            isCurrentUrl: true,
          },
        ]}
      />
    </div>
    {#if !hasVariationContainer || (hasVariationContainer && $optimizelyStore.isReady)}
      {#each data.pageData?.panelsCollection as panel, index}
        <div class="w-full mx-auto {makePanelOption(panel, 'contentPage', index).style}">
          <svelte:component
            this={makePanelOption(panel, 'contentPage', index).component}
            {...makePanelOption(panel, 'contentPage', index).props}
          />
        </div>
      {/each}
    {/if}
    {#if path.includes('cookie')}
      <Button
        id="ot-sdk-btn"
        text="Cookie Settings"
        variant={BUTTON_VARIANT.PRIMARY}
        buttonSize={BUTTON_SIZE.LARGE}
        customClass="ot-sdk-show-settings !text-white !text-md !px-2 !md:px-8 !py-2.5 !border-white !w-100 mx-auto max-w-1280"
      ></Button>
    {/if}
  </ContentPageLayout>
{/if}
